'use strict';

var rankingsPerformingScales = require('../factories/RankingsPerformingScales');
var ChartDashboardRankingsPerformingDirective = function ChartDashboardRankingsPerformingDirective($rootScope, $timeout, Chart, chartYAxis, brushRangesService, chartConstants, chartDashboardRankingsDataService) {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-rankings-performing.html'),
    controller: 'ChartDashboardRankingsPerformingController',
    scope: {
      data: '=',
      label: '@',
      rankingType: '@',
      type: '@',
      screenState: '=',
      isVisible: '=',
      ranking: '=',
      brushSelections: '='
    },
    link: function link($scope, element) {
      var chartDataMissing = element.find('.data-missing');
      var yAxisLeft = chartYAxis($scope.chartFormatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).label($scope.label).withoutHorizontalLines();
      var elem = element.find('.chart-container.chart-rankings-performing');
      var chartRankingsPerforming = new Chart(elem, $scope.chartFormatters, rankingsPerformingScales, yAxisLeft, $scope.type === 'under');
      $scope.renderChartDataPresent = function (data) {
        chartRankingsPerforming.render(data, $scope.brushRanges);
        $timeout(function () {
          $scope.$broadcast('perfect-scrollbar:update');
        }, 0);
      };
      function getErrorMessage() {
        if (!$scope.isDataPresent) {
          var ranking = $scope.ranking.name === 'MARKET' ? 'markets' : $scope.ranking.name;
          return 'No ' + ($scope.type === 'over' ? 'overperforming' : 'underperforming') + ' ' + ranking + ' found';
        }
      }
      $scope.renderChart = function () {
        if ($scope.data !== undefined && $scope.isVisible) {
          yAxisLeft.label($scope.label);
          $scope.isDataPresent = $scope.data && $scope.data.length > 0;
          $scope.toggleVisibility($scope.isDataPresent);
          $scope.setErrorMessage($scope.data, getErrorMessage());
          $scope.renderChartDataPresent($scope.data);
        }
      };
      $scope.toggleVisibility = function (dataPresent) {
        if (dataPresent) {
          chartDataMissing.hide();
        } else {
          chartDataMissing.show();
        }
      };
      $scope.timeoutReload = function () {
        $timeout($scope.renderChart, 0);
      };
      $scope.$watch('data', function () {
        if ($scope.data !== undefined) {
          $scope.brushRanges = $scope.calculateBrushRanges();
          $scope.minWidth = $scope.data.length * chartDashboardRankingsDataService.getBarSpaceWidth() + 20;
          $scope.renderChart();
        }
      });
      $scope.$watch('isVisible', function (newValue) {
        if (newValue && $scope.data) {
          $scope.timeoutReload();
        }
      });
      $scope.$on('dashboard:rankings:clearBrush', function (event, chartType) {
        if ($scope.type === chartType && $scope.isVisible) {
          chartRankingsPerforming.clearBrush();
        }
      });
      $scope.$on('dashboard:ranking:reset-selection', function () {
        if ($scope.isVisible) {
          chartRankingsPerforming.setInitialSelection([0, $scope.data.length], true);
        }
      });
      chartRankingsPerforming.on('rangechangeend', function (brushRanges, silent) {
        $scope.brushRanges = brushRanges;
        $scope.updateBrushSelections(brushRanges);
        $scope.$emit('dashboard:ranking:brush-filter');
        if (!silent) {
          var oppositeChart = $scope.type === 'over' ? 'under' : 'over';
          $rootScope.$broadcast('dashboard:rankings:clearBrush', oppositeChart);
        }
      });
      element.on('contextmenu', function () {
        //prevent default context menu
        return false;
      });
    }
  };
};
ChartDashboardRankingsPerformingDirective.$inject = ['$rootScope', '$timeout', 'ChartDashboardRankings', 'ChartElementsYAxis', 'BrushRangesService', 'ChartElementsConstants', 'ChartDashboardRankingsDataService'];
module.exports = ChartDashboardRankingsPerformingDirective;